import { formatShortDuration } from "../../../common/common_funcs.js";
import { OfferService } from "../../../offers/offer_service.js";
import type { ChainLayout } from "../../../offers/offer_service.js";

export function getChainOfferRemainingMs( layout: ChainLayout = 'chain_default' ): number | null
{
  const offer = OfferService.getChainOffers( layout )[0];
  if ( !offer ) return null;

  const deadline_ms = OfferService.getOfferDisplayEndMs( offer );
  if ( deadline_ms === null ) return null;

  const now_ms = OfferService.getServerNowMs() ?? Date.now();
  return Math.max( 0, deadline_ms - now_ms );
}

export function formatChainOfferRemaining( ms: number | null ): string
{
  if ( ms === null ) return '';
  return formatShortDuration( ms );
}
